/**
 * @export
 *  Providers
 */
export enum PROVIDERS {
  BETSOFT = 1,
  LIVE_WAGERING = 2,
  ESPORTS = 3,
  DGS_CASINO = 4,
  HORSES = 5,
  CONCEPT = 6,
  PLATINUM = 7,
  PROPS_BUILDER = 8,
  RACEBOOK = 9,
  VIG = 10,
  ALL_WAY_SPIN = 11,
  BBTECH = 12,
  BET2TECH = 13,
  BGAMING = 14,
  CYBERSLOTS = 15,
  DRAGON_GAMING = 16,
  FELIX = 17,
  FRESH_DECK = 18,
  FUNTA_GAMING = 19,
  GAMZIX = 20,
  INBET = 21,
  JUSTPAY = 22,
  KAGAMING = 23,
  NUCLEUS_GAMING = 24,
  ORBITAL = 25,
  RIVAL = 26,
  SAGAMING = 27,
  SIMPLEPLAY = 28,
  SPADEGAMING = 29,
  SUPERLOTTO = 30,
  TPG = 31,
  POKER = 32,
  APOLLO_PLAY = 33,
  BLUE_WHALE = 34,
  COOL_GAMES = 35,
  FUNKY_GAMES = 36,
  LOTTO_INSTANT_WIN = 37,
  MANCALA_GAMING = 38,
  MR_SLOTY = 39,
  PLAYBRO = 40,
  SPINTHON = 41,
  THUNDERSPIN = 42,
  TVBET = 43,
  ZEUSPLAY = 44,
  EVOPLAY_ENTERTAINMENT = 45,
  SLOT_FACTORY = 46,
  SUPER_SPADE_GAMES = 47,
  TURBO_GAMES = 48,
  ARROWS_EDGE = 49,
  BETSOLUTIONS = 50,
  ONLYPLAY = 51,
  SMARTSOFT_GAMING = 52,
  VIBRA_GAMING = 53,
}
